module.exports = __webpack_public_path__ + "img/node.b337a2fb.svg";